import {
  Input as InputNimbus,
  InputProps as InputNimbusProps,
  Box,
  Text,
  Textarea,
  TextFontSizeProperties,
  BoxMarginProperties,
  TextColorProperties,
} from '@nimbus-ds/components';

interface InputProps
  extends Omit<InputNimbusProps, 'onChange' | 'onBlur' | 'appearance'> {
  onChange?: (params: { name: string; value: string }) => void;
  onBlur?: (params: { name: string; value: string }) => void;
  label?: string | null;
  helpText?: string | null;
  helpTextColor?: TextColorProperties;
  helpTextFontSize?: TextFontSizeProperties;
  marginBottom?: BoxMarginProperties;
  append?: React.ReactNode;
  lines?: number;
  appearance?: 'neutral' | 'success' | 'warning' | 'danger' | 'ai-generative';
  aiGenerated?: boolean;
}

function Input({
  onChange,
  onBlur,
  label,
  helpText,
  helpTextColor = 'danger-textLow',
  helpTextFontSize = 'base',
  marginBottom = '4',
  aiGenerated,
  ...props
}: Readonly<InputProps>) {
  const handleOnChange = ({ target: { name, value } }) =>
    onChange?.({ name, value });

  const handleOnBlur = ({ target: { name, value } }) =>
    onBlur?.({ name, value });

  return (
    <Box
      data-style="stratus--input"
      display="flex"
      flexDirection="column"
      gap="2"
      marginBottom={marginBottom}
    >
      {!!label && <Text color="neutral-textLow">{label}</Text>}
      {props.type === 'password' ? (
        <InputNimbus.Password
          {...props}
          value={props.value ?? ''}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          aiGenerated={aiGenerated}
        />
      ) : props.type === 'textarea' ? (
        <Textarea
          name={props.name}
          id={props.id || 'textarea'}
          value={props.value ?? ''}
          placeholder={props.placeholder}
          appearance={props.appearance}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          disabled={props.disabled}
          lines={props.lines || 4}
          aiGenerated={aiGenerated}
        />
      ) : (
        <InputNimbus
          {...props}
          value={props.value ?? ''}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          aiGenerated={aiGenerated}
        />
      )}
      {!!helpText && (
        <Text fontSize={helpTextFontSize} color={helpTextColor}>
          {helpText}
        </Text>
      )}
    </Box>
  );
}

export default Input;
